<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <lorem-ipsum :repeats="5" data-root-margin="1px" data-threshold="1.0" v-intersect="onIntersect" :class="['text-sm', 'mb-8']" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageIntersect',
  mixins: [
    methods
  ],
  methods: {
    onIntersect ($event) {
      this.log('intersect', 'v-intersect', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/directives/intersect.vue